<template>
  <section id="Amenities">
    <div id="AmenitiesAnchor" />
    <b-container>
      <div class="content section-title">
        <div class="title-box">
          <div class="title">Amenities And<span>Benefits</span></div>
        </div>
      </div>
      <div class="content benefits">
        <NewAmenitiesCards />
        <AmenitiesCards />
        <div class="benefits-note">
          * Limited access for United Club members to complimentary game tickets for select away games. Subject to availability.
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
  import NewAmenitiesCards from "@/components/sections/Amenities/NewAmenitiesCards";
  import AmenitiesCards from "@/components/sections/Amenities/AmenitiesCards";
  import { mapState } from "vuex";

  export default {
    name: "Amenities",
    components: {
      AmenitiesCards,
      NewAmenitiesCards
    },
    computed: {
      ...mapState(["global"]),
    }
  }
</script>

<style lang="scss" scoped>
  #Amenities {
    position: relative;
    background: linear-gradient(0deg, #FFF 0%, #F8F8F8 100%);
    width: 100%;
    padding: 85px 0 55px;
    #AmenitiesAnchor {
      position: absolute;
      top: 0;
      left: 0;
    }
    .container {
      position: relative;
      width: 1040px;
      z-index: 2;
    }
    .content {
      &.section-title {
        justify-content: space-between;
        margin-bottom: 20px;
        .title-box {
          width: 100%;
          &.dark-bg {
            .title {
                color: $orange;
              span {
                color: $white;
              }
            }
            .underline {
                background: #021734;
              &.full {
                max-width: 100%;
              }
            }
          }
          &.orange-bg {
            .title {
              color: $white;
              span {
              color: $blue;
              }
            }
            .underline {
              background: #C43A00;
            }
          }
          &.payment-plans {
            display: flex;
            flex-direction: column;
            width: 100%;
          }
          &.seating-map {
            margin-bottom: 80px;
          }
          &.account-profile {
            margin-bottom: 50px;
          }
          .title {
            z-index: 2;
            position: relative;
            text-align: left;
            font-size: 22px;
            @include nofex;
            line-height: 31px;
            text-transform: uppercase;
            color: $orange;
            span {
              position: relative;
              display: block;
              font-size: 58px;
              @include nexaBold;
              line-height: 1;
              color: $dark-blue;
            }
          }
          .plan-info {
            max-width: 560px;
            margin: 20px 0 10px;
            p {
              font-size: 14px;
              @include nexaBold;
              line-height: 18px;
              text-align: left;
              color: $white;
              a {
                text-decoration: underline;
                color: $white;
              }
            }
          }
          .underline {
            width: 100%;
            max-width: 470px;
            margin-top: 20px;
            height: 6px;
          }
        }
      }
      &.benefits {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        gap: 10px;
      }
    }
    .benefits-note {
      margin-top: 15px;
      font-size: 10px;
      @include nexaBold;
      line-height: 18px;
      color: #092244;
    }
    .newAmenities-note {
      margin: 5px 0;
      @include semiBold;
      font-size: 15px;
      line-height: 18px;
      color: $dark-blue;
    }
    .plus {
      display: flex;
      flex-direction: row;
      background: rgba(0,42,92,0.8);
      height: fit-content;
      @media (max-width: $lg) {
        flex-direction: column;
      }
      .left {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        background: #ffffff;
        border-radius: 3px;
        min-height: 100%;
        width: 50%;
        padding: 70px 5% 63px 0;
        @media (max-width: $xl) {
          padding-right: 3%;
        }
        @media (max-width: $lg) {
          width: 100%;
        }
        .new2021 {
          position: absolute;
          top: -11.34px;
          right: 25%;
          transform: translateX(15%);
          height: 22.68px;
          width: 133.81px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f26522;
          border-radius: 1.7px;
          font-family: AvenirNextCondensed-HeavyItalic;
          font-size: 18.48px;
          line-height: 14.39px;
          color: #ffffff;
          text-transform: uppercase;
          @media (max-width: $md) {
            right: 20%;
          }
        }
        .phone {
          position: absolute;
          left: 1%;
          bottom: 0;
          height: 110%;
          object-fit: contain;
          @media (max-width: $lg) {
            left: 8%;
          }
          @media (max-width: $md) {
            left: 5%;
          }
        }
        .broncos {
          width: 55%;
          object-fit: contain;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        width: 50%;
        padding: 22px 25px 6px 21px;
        @media (max-width: $lg) {
          width: 100%;
        }
        .top {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          @media (max-width: $md) {
            flex-direction: column;
            justify-content: center;
          }
          &-left {
            width: 50%;
            @media (max-width: $md) {
              width: 100%;
            }
            h4 {
              font-family: AvenirNextCondensed-Bold;
              font-size: 16px;
              line-height: 19px;
              color: #ffffff;
              text-transform: uppercase;
              width: 100%;
              max-width: 200px;
              span {
                color: #f26522;
              }
            }
          }
          &-right {
            width: 50%;
            @media (max-width: $md) {
              width: 100%;
              margin-top: 17px;
            }
            p {
              font-family: AvenirNextCondensed-Medium;
              font-size: 14px;
              line-height: 20px;
              letter-spacing: 0;
              color: #ffffff;
              width: 100%;
            }
          }
        }
        .middle {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          margin: 15px 0 5px 0;
          &-holder {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            max-width: 320px;
            border-radius: 2px;
            background-color: rgba(255,255,255,0.1);
            padding: 12px 24px 13px 21px;

            .green {
              font-family: AvenirNextCondensed-Bold;
              font-size: 16px;
              line-height: 25px;
              color: #1CC17F;
            }
            p {
              font-family: AvenirNextCondensed-Medium;
              font-size: 16px;
              line-height: 25px;
              color: #ffffff;
              text-transform: uppercase;
            }
          }
        }
        .bottom {
          font-family: AvenirNextCondensed-Medium;
          font-size: 11px;
          line-height: 20px;
          color: #ffffff;
          opacity: 0.34;
        }
      }
    }
    .save {
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: rgba(0,18,40,0.8);
      padding: 19px 23px;
      width: fit-content;
      margin: 24px auto 46px auto;
      border-bottom: 2px solid #1CC17F;
      p {
        font-family: AvenirNextCondensed-Bold;
        font-size: 16px;
        line-height: 19px;
        color: #ffffff;
        text-transform: uppercase;
        span {
          color: #1cc17f;
        }
      }
      svg {
        height: 18px;
        object-fit: contain;
        margin-right: 20px;
      }
    }
  }
</style>